import React from 'react';
import { DefaultAccordion } from '../Accordion/DefaultAccordion';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { isEmptyObject } from '../../../lib/typeGuards';
import ContentMessage from '../ContentMessage/ContentMessage';
import { MembershipKey, MembershipsByPageType, UserMembershipDefault, UserMembershipEdit } from './UserMembershipTypes';
import { UserMembershipsContentList } from './UserMembershipsContentList';

export type UserMembershipAccordion<T> = MembershipsByPageType<Record<any, T[]>> & { order: MembershipKey[] };

export function UserMembershipAccordion<T extends UserMembershipEdit | UserMembershipDefault>({
  memberships,
  order,
}: UserMembershipAccordion<T>) {
  const { t } = useSonTranslation('UserMemberships');

  if (!memberships || isEmptyObject(memberships)) {
    return <ContentMessage text={t('noItems')} />;
  }

  const accordionElements = order
    .map(key => ({
      key,
      id: key,
      category: t(`categories.${key}`),
      sortedMemberships: memberships[key],
    }))
    .filter(s => s.sortedMemberships !== undefined);

  return (
    <DefaultAccordion data={accordionElements} initialActiveElementId={accordionElements[0].id}>
      {({ sortedMemberships }) => <UserMembershipsContentList hierarchy={4} memberships={sortedMemberships} />}
    </DefaultAccordion>
  );
}
